(function(angular){
	'use strict';
	
	angular
		.module('productPage')
		.controller('ProductPageCtrl', [
			'ReitElementFactory',
			ProductPageCtrl
		]);
	
	function ProductPageCtrl(
		ReitElementFactory) {
		var productPage = this;

		productPage.reitHistoricalPerformance = {
			quarters: [{
				name: 'Q1',
				months: ['Jan', 'Feb', 'Mar']
			},{
				name: 'Q2',
				months: ['Apr', 'May', 'Jun']
			},{
				name: 'Q3',
				months: ['Jul', 'Aug', 'Sep']
			},{
				name: 'Q4',
				months: ['Oct', 'Nov', 'Dec']
			}]
		};

		(function init() {
			angular.extend(productPage, globalConfig);

			ReitElementFactory.getReitElementsForReit(productPage.reitId, ['flatReitElementListByStatusWithWeights'])
				.then(function(reitElementLists) {
					productPage.reitElements = reitElementLists.flatReitElementListByStatusWithWeights;
				});
		})();
	}
})(window.angular);
